import { QUERY_PARAMS } from "../utils/shared/constants";

export const parseQueryParam = () => {
    const search = window.location.search;
    const urlParams = new URLSearchParams(search);
    return {
        superUser: urlParams.get(QUERY_PARAMS.SUPER_USER) || '',
        orgType: urlParams.get(QUERY_PARAMS.ORG_TYPE) || '',
        newDeal: !!urlParams.get(QUERY_PARAMS.NEW_DEAL),
        dealId: urlParams.get(QUERY_PARAMS.DEAL_ID) || '',
        query: urlParams.get(QUERY_PARAMS.QUERY) || '',
        debug: !!urlParams.get(QUERY_PARAMS.DEBUG),
        orgId: urlParams.get(QUERY_PARAMS.ORG_ID) || '',
        id: urlParams.get(QUERY_PARAMS.ID) || '',
        back: !!urlParams.get(QUERY_PARAMS.BACK),
        authToken: urlParams.get(QUERY_PARAMS.AUTH_TOKEN) || '',
        tab: urlParams.get(QUERY_PARAMS.TAB) || '',
        code: urlParams.get(QUERY_PARAMS.CODE) || '',
        state: urlParams.get(QUERY_PARAMS.STATE) || '',
    }
}

const useQueryParam = () => {
    return parseQueryParam();
}

export const addQueryParam = (key: string, value: string) => {
    const search = window.location.search;
    const urlParams = new URLSearchParams(search);
    urlParams.set(key, value);
    return urlParams.toString();
}

export default useQueryParam;